import React, { useState, useEffect } from "react";
import Signature from "../../assets/images/Signature.png";
import moment from "moment";
import Logo from "../../assets/images/Plus_Minua_logo.png";
import axios from "axios";
import config from "../../Config";
import { useParams } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';

const InvoicePrint = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
  const [DefaultFYear, setDefaultFYear] = useState(localStorage.getItem("DefaultFYear"));
  const [Loading, setLoading] = useState(false)
  const [Invoice, setInvoice] = useState({})

  let params = useParams()
  const [ID, setID] = useState(params.id);

  useEffect(() => {

    document.title = "DPS Kasur Invoice";
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: ID,
    };
    // console.log(data)

    var api_config = {
      method: 'post',
      url: config.base_url + 'PaymentInvoice/PrintInvoice',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };


    axios(api_config)
      .then(function (response) {
        // console.log(response.data);
        if (response.data.status_code == 1) {

          setInvoice(response.data.InvoiceData)
          setLoading(false);
        }
        else {
          setLoading(false)
        }

      })
      .catch(function (error) {
        //console.log(error);
      });

  }, []);

  const formatAmount = (value) => {
    if (value === null || value === undefined) {
      return "0";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
      return "0";
    }
    return numeric.toLocaleString();
  };

  const getInvoiceDate = () => {
    if (Invoice?.InvoiceMonth && Invoice?.InvoiceYear) {
      return moment({
        year: Number(Invoice.InvoiceYear),
        month: Number(Invoice.InvoiceMonth) - 1,
        day: 25,
      });
    }
    return Invoice?.GeneratedDate ? moment(Invoice.GeneratedDate) : moment();
  };

  const invoiceDate = getInvoiceDate();
  const invoiceMonthLabel = invoiceDate.format("MMMM YYYY");

  return (
    <>

      <div className="page a4 potrait invoice-page">
        <div className="content a4">
          <div className="invoice-header">
            <div className="row align-items-start">
              <div className="col-6">
                <img src={Logo} />
              </div>
              <div className="col-6">
                <ul>
                  <li>website Development</li>
                  <li>Software Development</li>
                  <li>Domain Hosting</li>
                </ul>
              </div>
            </div>
            <div className="row align-items-center my-3">
              <div className="col-6 ps-5">
                <h1>Invoice</h1>
              </div>
              <div className="col-6">
                <div className="date">
                  <span>Date</span>
                  <p>{invoiceDate.format("D MMMM , YYYY")}</p>
                </div>
              </div>
            </div>

          </div>
          <div className="invoice-content">
            <p className="">
              As per service agreement with <strong>M/S DPS Kasur</strong> , I as Service Provider I have launched new software i.e. School Management System with dashboard support. However now, as per agreement monthly service charges are required to be released as below:
            </p>

            <table className="table table-sm table-bordered table-theme">
              <thead>
                <tr>
                  <th>Sr. #</th>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {
                  Loading ? <tr>
                    <td className="text-center" colspan="70">
                      <Spinner animation="border" role="status"></Spinner>
                    </td>
                  </tr> :
                    <>
                      <tr>
                        <td>1.</td>
                        <td>Service Charges for the Month of {invoiceMonthLabel}</td>
                        <td>{formatAmount(Invoice.InvoiceAmount)}/-</td>
                      </tr>
                      <tr>
                        <th></th>
                        <th>Total Amount.</th>
                        <th>Rs. {formatAmount(Invoice.InvoiceAmount)}/-</th>
                      </tr>
                    </>
                }

              </tbody>
            </table>
            <p>
              Please make arrangement for the release of this invoice in favour of "Muhammad Ali Imran" proprietor of M/S Plus Minus Systems Kasur and oblige.
            </p>
            <div className="text-end">
              <img style={{ width: "60px", marginRight: '50px' }} src={Signature} alt="" />
              <h6 className="text-end mt-1">
                Muhammad Ali Imran
              </h6>
            </div>
          </div>
          <div className="invoice-footer mt-2">
            <ul>
              <li>+92 323 6590065</li>
              <li>info@plusminussystems.com</li>
              <li>www.plusminussystems.com</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicePrint